export default safe => {
  console.log(safe); //vue的this对象
  return {
    lazy: true,
    tip: false,
    simplePage: true,
    searchShow: true,
    // searchMenuSpan: 6,
    tree: true,
    border: true,
    /** 表格索引 */
    index: false,
    /** 表格搜索显隐按钮 */
    searchShowBtn: true,
    /** 是否启用功能按钮 */
    searchIcon: true,
    searchIndex: 0,
    /** 表格查看按钮 */
    viewBtn: false,
    /** 表格新增按钮 */
    addBtn: false,
    /** 表格删除按钮 */
    delBtn: false,
    /** 表格修改按钮 */
    editBtn: false,
    /** 表格搜索按钮 */
    // searchBtn: false,
    /** 表格清空按钮 */
    // emptyBtn: false,
    /** 开启拖拽功能 */
    // sortable: true,
    // dragHandler: true,
    // rowSort: true,
    // columnSort: true,
    menuWidth: 200,
    column: [{
        label: "策略ID",
        prop: "id",
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: false,
        // search: true,
        columnBtn: false
        /** 搜索项位置排序，序号越大越靠前 */
        // searchOrder: 1,
      },
      {
        label: "策略名称",
        prop: "name",
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: true
        // search: true,
        /** 搜索项位置排序，序号越大越靠前 */
        // searchOrder: 1,
      },
      // {
      //   label: '策略场景',
      //   prop: 'mediaSource'
      // },
      {
        label: "策略描述",
        prop: "descr",
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: true
      },
      {
        label: "媒资数量",
        prop: "mediaNum"
      },
      {
        label: "展示配置",
        prop: "imgType",
        dicData: [{
            label: "横图样式",
            value: 1
          },
          {
            label: "竖图样式",
            value: 2
          }
        ]
      },
      {
        label: "状态",
        prop: "status",
        dicData: [{
            label: "生效",
            value: 1
          },
          {
            label: "失效",
            value: 0
          }
        ]
      },
      {
        label: "更新人",
        prop: "updateUser"
      },
      {
        label: "更新时间",
        prop: "updateTime"
      },
      {
        label: "",
        prop: "my",
        hide: true,
        showColumn: false,
        search: true,
        display: false,
        menuClassName: "myClass",
        searchslot: true
      }
    ]
  };
  // return {
  //   title: '表格的标题',
  //   sortable: true,
  //   dragHandler: true,
  //   border: true,
  //   align: 'center',
  //   menuAlign: 'center',
  //   column: [
  //     {
  //       label: '姓名',
  //       prop: 'name'
  //     },
  //     {
  //       label: '性别',
  //       prop: 'sex'
  //     },
  //     {
  //       label: '日期',
  //       prop: 'date',
  //       type: 'date',
  //       format: 'yyyy-MM-dd hh:mm:ss',
  //       valueFormat: 'yyyy-MM-dd hh:mm:ss'
  //     }
  //   ]
  // };
};
